var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg25Star24B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -10 150 150",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 59.82677l9.952638 -6.5662766l-7.91409 -8.91803l11.312678 -3.7663116l-5.3359585 -10.662767l11.902236 -0.7101288l-2.3946476 -11.680401l11.680401 2.3946476l0.7101288 -11.902236l10.662767 5.3359585l3.7663116 -11.312678l8.91803 7.91409l6.5662766 -9.952638l6.5662804 9.952638l8.91803 -7.91409l3.7663116 11.312678l10.6627655 -5.3359585l0.7101288 11.902236l11.680397 -2.3946476l-2.3946457 11.680401l11.902237 0.7101288l-5.3359604 10.662767l11.312683 3.7663116l-7.914093 8.91803l9.952637 6.5662766l-9.952637 6.5662804l7.914093 8.91803l-11.312683 3.7663116l5.3359604 10.6627655l-11.902237 0.7101288l2.3946457 11.680397l-11.680397 -2.3946457l-0.7101288 11.902237l-10.6627655 -5.3359604l-3.7663116 11.312683l-8.91803 -7.914093l-6.5662804 9.952637l-6.5662766 -9.952637l-8.91803 7.914093l-3.7663116 -11.312683l-10.662767 5.3359604l-0.7101288 -11.902237l-11.680401 2.3946457l2.3946476 -11.680397l-11.902236 -0.7101288l5.3359585 -10.6627655l-11.312678 -3.7663116l7.91409 -8.91803z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25Star24B);
export default __webpack_public_path__ + "static/media/25-star-24b.c7b3ebf9bdc23e7d1818eb5108e65e1a.svg";
export { ForwardRef as ReactComponent };